const code = {
  title: 'Code de vérification',
  codeLabel: 'Code de vérification',
  confirmButtonText: 'Vérifier',
  cancelButtonText: 'Recommencer la configuration',
  instructions: {
    title: 'Je n\'ai pas reçu de code',
    instruction1: 'Attendez quelques minutes',
    instruction2: 'Essayez de renvoyer le code de vérification',
    instruction3: 'Contactez le service à la clientèle',
  },
  messages: {
    codeFormat: 'Le code de vérification doit contenir des nombres uniquement',
    invalidCode: 'Le code de vérification est invalide.',
    formError: 'Nous avons trouvé quelques erreurs. Veuillez examiner le formulaire et effectuer les corrections adéquates.',
    formAttemptsError: 'Vous avez dépassé le nombre autorisé de tentatives de saisie du code de vérification. Par mesure de sécurité, veuillez contacter notre <1>service à la clientèle au 1 888 610-5101</1> pour obtenir de l\'aide ou demander <3>l\'envoi d\'un nouveau code.</3>',
  },
};

export default {
  title: 'Authentification multifacteur',
  steps: {
    password: {
      title: 'Authentification multifacteur',
      info: 'L\'authentification multifacteur est un processus de validation en deux étapes qui vous demande de fournir deux types d\'information pour confirmer votre identité lors de votre connexion. Pour modifier vos facteurs d\'authentification ou en configurer de nouveaux, veuillez saisir votre mot de passe.',
      factorTitle: 'Facteur(s) configuré(s)',
      passwordLabel: 'Mot de passe',
      confirmButtonText: 'Continuer',
      messages: {
        ...code.messages,
      },
    },
    informations: {
      title: 'Authentification multifacteur',
      info: '<p>Veuillez confirmer vos informations pour configurer vos facteurs d\'authentification et renforcer la sécurité de votre connexion.</p><p>Ces informations serviront uniquement à configurer vos facteurs d\'authentification, sans mise à jour du profil client.</p>',
      emailLabel: 'Courriel',
      phoneLabel: 'Téléphone',
      confirmButtonText: 'Confirmer',
    },
    email: {
      ...code,
      info: 'Un code de vérification vous sera envoyé afin de valider votre adresse courriel.',
      description: 'Envoyer un code par courriel à l\'adresse {{information}}.',
      confirmButtonText: 'Recevoir un code par courriel',
    },
    emailCode: {
      ...code,
      info: 'Veuillez entrer le code de vérification que nous avons envoyé par courriel à l\'adresse {{information}}',
    },
    phone: {
      ...code,
      info: 'Un code de vérification vous sera envoyé afin de valider votre numéro de téléphone {{information}}',
      methodLabel: 'Comment voulez-vous recevoir le code de vérification ?',
      smsMethodLabel: 'Par message texte',
      callMethodLabel: 'Par appel vocal',
      methods: {
        sms: {
          confirmButtonText: 'Recevoir un code par message texte',
        },
        voice: {
          confirmButtonText: 'Recevoir un code par appel vocal',
        },
      },
    },
    phoneCode: {
      ...code,
      info: 'Veuillez entrer le code de vérification que nous avons envoyé par {{method}} au {{information}}',
      methods: {
        sms: {
          name: 'message texte',
        },
        voice: {
          name: 'appel vocal',
        },
      },
    },
    confirmation: {
      title: 'Merci!',
      description: 'Vos facteurs d\'authentification sont en cours de configuration. Lors de votre prochaine connexion, vous devrez fournir un code de vérification à usage unique pour confirmer votre identité.',
      confirmButtonText: 'Aller à l\'Espace client',
    },
  },
};
